import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { ErrorBoundary } from '../components/ui/ErrorBoundary'
import { useTerminalStore } from '../store/terminalStore'

export function RootLayout() {
  const theme = useTerminalStore((s) => s.theme)

  useEffect(() => {
    document.documentElement.classList.toggle('light', theme === 'light')
  }, [theme])

  return (
    <ErrorBoundary>
      <Outlet />
    </ErrorBoundary>
  )
}
